/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowCmdbQuerySyncLogResourceId extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ServiceNowCmdbQuerySyncLogResourceId");
    }

    getFixupPrototypeFunction() { return ServiceNowCmdbQuerySyncLogResourceId.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowCmdbQuerySyncLogResourceId>): ServiceNowCmdbQuerySyncLogResourceId {
        let obj = Object.assign(new ServiceNowCmdbQuerySyncLogResourceId(), model);
        ServiceNowCmdbQuerySyncLogResourceId.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowCmdbQuerySyncLogResourceId>): ServiceNowCmdbQuerySyncLogResourceId {
        if (!model) return null;
        return ServiceNowCmdbQuerySyncLogResourceId.newInstance(<ServiceNowCmdbQuerySyncLogResourceId> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowCmdbQuerySyncLogResourceId) {
        if (!obj) return;

        models.ServiceNowCmdbQuerySyncLogResourceId.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowCmdbQuerySyncLogResourceId): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceNowCmdbQuerySyncLogResourceId.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Unique identifiers for the synchronized resource
     */
    resource_ids: Array<string>;

}
